var _Skeleton, _ExternalLink;
import { useCallback } from "react";
import cn from "clsx";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import ExternalLink from "@crehana/compass.icons.outline/ExternalLink";
import { Collapse, Skeleton } from "@crehana/compass.ui";
import { CourseCard, CourseCardSkeleton } from "../components";
import { useCatalogEmptyStateContext } from "../context";
import { useCatalogEmptyStateTranslations } from "../hooks";
import CoursesCounterTag from "../ui/CoursesCounterTag";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CatalogCourseCards = function CatalogCourseCards() {
  var _useCatalogEmptyState = useCatalogEmptyStateContext(),
    selectedCategory = _useCatalogEmptyState.selectedCategory,
    currentCourses = _useCatalogEmptyState.currentCourses,
    currentCatalogByCategoryLink = _useCatalogEmptyState.currentCatalogByCategoryLink,
    isLoadingCourses = _useCatalogEmptyState.isLoadingCourses,
    isLoadingAllCategories = _useCatalogEmptyState.isLoadingAllCategories,
    totalCoursesByCurrentCategory = _useCatalogEmptyState.totalCoursesByCurrentCategory,
    source = _useCatalogEmptyState.source;
  var _useCatalogEmptyState2 = useCatalogEmptyStateTranslations(),
    t = _useCatalogEmptyState2.t;
  var shouldShowTitle = !!selectedCategory;
  var categoryTitle = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.label;
  var title = shouldShowTitle && t('CATALOG_EMPTY_STATE_COURSES_TITLE', {
    interpolation: {
      name: categoryTitle
    }
  });
  var renderCourseCardSkeletons = useCallback(function () {
    return Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/_jsx(CourseCardSkeleton, {}, index);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Collapse, {
      open: shouldShowTitle,
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center tw-mb-1.6",
        children: [isLoadingCourses ? _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-3.2 tw-h-2.4 tw-rounded-0.4 tw-mr-1.2",
          animated: true
        })) : /*#__PURE__*/_jsx(CoursesCounterTag, {
          label: totalCoursesByCurrentCategory
        }), /*#__PURE__*/_jsx("h4", {
          className: "tw-font-subtitle4",
          children: title
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cn('tw-grid tw-gap-1.2 tw-grid-cols-1 md:tw-grid-cols-2', shouldShowTitle && 'tw-mb-1.6'),
      children: isLoadingCourses || isLoadingAllCategories ? renderCourseCardSkeletons() : currentCourses.map(function (course) {
        var courseDetail = createUrlWithSourceQueryParams({
          url: "/clases/v2/".concat(course.originalId, "/detalle/"),
          source: source,
          sourceDetail: 'Catalog Empty State Course Card'
        });
        return /*#__PURE__*/_jsx(CourseCard, {
          title: course.title,
          level: course.level,
          coverImage: course.coverImage,
          duration: course.duration,
          href: courseDetail
        }, course.originalId);
      })
    }), /*#__PURE__*/_jsx(Collapse, {
      open: shouldShowTitle,
      children: /*#__PURE__*/_jsxs("a", {
        href: currentCatalogByCategoryLink,
        className: cn(
        // Flex
        'tw-flex tw-items-center tw-justify-center',
        // Font
        'tw-font-subtitle4 tw-text-center tw-text-primary-light-500 dark:tw-text-secondary-dark-500',
        // Size + Spacing
        'tw-w-auto tw-mx-auto'),
        children: [/*#__PURE__*/_jsx("span", {
          className: "tw-mr-0.4",
          children: t('CATALOG_EMPTY_STATE_SHOW_MORE')
        }), _ExternalLink || (_ExternalLink = /*#__PURE__*/_jsx(ExternalLink, {
          size: 20,
          className: "tw-fill-current"
        }))]
      })
    })]
  });
};
CatalogCourseCards.displayName = 'CatalogCourseCards';
export default CatalogCourseCards;